import React from "react";
import ComboBox from "../ComboBox";

/**
 * Admin-only Peer Reviewer picker (auditor list). Ticket 14744.
 */
export default function AssessmentAdminPeerReviewerField({
  updateActive,
  setValue,
  watch,
  options,
  displayName,
  errors,
}) {
  return (
    <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
      <h2 className="text-sm font-medium text-gray-900">Peer Reviewer</h2>
      <div className="mt-1 text-sm/6 text-black sm:col-span-2 sm:mt-0">
        {updateActive ? (
          <ComboBox
            data={options}
            placeHolder="Select Peer Reviewer..."
            setSelected={(value) => setValue("peerReviewer", value)}
            selected={watch("peerReviewer")}
            width="w-full"
            inputWidth="w-full"
          />
        ) : (
          <span>{displayName || "-"}</span>
        )}
        {errors?.peerReviewer?.message ? (
          <span data-testid="peer-reviewer-error">
            {errors.peerReviewer.message}
          </span>
        ) : null}
      </div>
    </div>
  );
}
